// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.formlogin {
    display: flex;
    flex-direction: column;
    gap: 10px;
    background: linear-gradient(45deg, skyblue, darkblue);
    padding: 30px;
    width: 100%;
    border-radius: 20px;
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Open Sans", "Helvetica Neue", sans-serif;
    transition: background 0.3s ease;

}

.formlogin:hover {
    background: linear-gradient(45deg, darkblue, skyblue);
}

::placeholder {
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen,
        Ubuntu, Cantarell, "Open Sans", "Helvetica Neue", sans-serif;
}

.formlogin button {
    align-self: flex-end;
}

.flex-columnlogin>label {
    color: white;
    font-weight: 600;
}

.inputFormlogin {
    border: 1.5px solid #ecedec;
    border-radius: 10em;
    height: 50px;
    display: flex;
    align-items: center;
    padding-left: 10px;
    transition: 0.2s ease-in-out;
    background-color: white;
}

.inputlogin {
    margin-left: 10px;
    border-radius: 10rem;
    border: none;
    width: 100%;
    height: 100%;
}

.inputlogin:focus {
    outline: none;
}

.inputFormlogin:focus-within {
    border: 1.5px solid orange;
}

.flex-rowlogin {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 10px;
    justify-content: space-between;
}

.flex-rowlogin>div>label {
    font-size: 14px;
    color: black;
    font-weight: 400;
}

.spanlogin {
    font-size: 14px;
    margin-left: 5px;
    color: white;
    font-weight: 500;
    cursor: pointer;
}

.button-submitlogin {
    position: relative;
    display: inline-block;
    padding: 15px 30px;
    text-align: center;
    letter-spacing: 1px;
    text-decoration: none;
    background: transparent;
    transition: ease-out 0.5s;
    border: 2px solid;
    border-radius: 10em;
    box-shadow: inset 0 0 0 0 blue;
    margin: 20px 0 10px 0;
    color: white;
    font-size: 15px;
    font-weight: 500;
    height: 50px;
    width: 100%;
    cursor: pointer;
}

.button-submitlogin:hover {
    color: white;
    box-shadow: inset 0 -100px 0 0 royalblue;
}

.button-submitlogin:active {
    transform: scale(0.9);
}

.plogin {
    text-align: center;
    color: white;
    font-size: 14px;
    margin: 5px 0;
}

.btnlogin {
    margin-top: 10px;
    width: 100%;
    height: 50px;
    border-radius: 10em;
    display: flex;
    justify-content: center;
    align-items: center;
    font-weight: 500;
    gap: 10px;
    border: 1px solid #ededef;
    background-color: white;
    cursor: pointer;
    transition: 0.2s ease-in-out;
}

.btnlogin:hover {
    border: 1px solid orange;
}`, "",{"version":3,"sources":["webpack://./src/Components/login.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,qDAAqD;IACrD,aAAa;IACb,WAAW;IACX,mBAAmB;IACnB,wIAAwI;IACxI,gCAAgC;;AAEpC;;AAEA;IACI,qDAAqD;AACzD;;AAEA;IACI;oEACgE;AACpE;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,2BAA2B;IAC3B,mBAAmB;IACnB,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,4BAA4B;IAC5B,uBAAuB;AAC3B;;AAEA;IACI,iBAAiB;IACjB,oBAAoB;IACpB,YAAY;IACZ,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,SAAS;IACT,8BAA8B;AAClC;;AAEA;IACI,eAAe;IACf,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,YAAY;IACZ,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,qBAAqB;IACrB,kBAAkB;IAClB,kBAAkB;IAClB,mBAAmB;IACnB,qBAAqB;IACrB,uBAAuB;IACvB,yBAAyB;IACzB,iBAAiB;IACjB,mBAAmB;IACnB,8BAA8B;IAC9B,qBAAqB;IACrB,YAAY;IACZ,eAAe;IACf,gBAAgB;IAChB,YAAY;IACZ,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,YAAY;IACZ,wCAAwC;AAC5C;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,eAAe;IACf,aAAa;AACjB;;AAEA;IACI,gBAAgB;IAChB,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,gBAAgB;IAChB,SAAS;IACT,yBAAyB;IACzB,uBAAuB;IACvB,eAAe;IACf,4BAA4B;AAChC;;AAEA;IACI,wBAAwB;AAC5B","sourcesContent":[".formlogin {\r\n    display: flex;\r\n    flex-direction: column;\r\n    gap: 10px;\r\n    background: linear-gradient(45deg, skyblue, darkblue);\r\n    padding: 30px;\r\n    width: 100%;\r\n    border-radius: 20px;\r\n    font-family: -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, Oxygen, Ubuntu, Cantarell, \"Open Sans\", \"Helvetica Neue\", sans-serif;\r\n    transition: background 0.3s ease;\r\n\r\n}\r\n\r\n.formlogin:hover {\r\n    background: linear-gradient(45deg, darkblue, skyblue);\r\n}\r\n\r\n::placeholder {\r\n    font-family: -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, Oxygen,\r\n        Ubuntu, Cantarell, \"Open Sans\", \"Helvetica Neue\", sans-serif;\r\n}\r\n\r\n.formlogin button {\r\n    align-self: flex-end;\r\n}\r\n\r\n.flex-columnlogin>label {\r\n    color: white;\r\n    font-weight: 600;\r\n}\r\n\r\n.inputFormlogin {\r\n    border: 1.5px solid #ecedec;\r\n    border-radius: 10em;\r\n    height: 50px;\r\n    display: flex;\r\n    align-items: center;\r\n    padding-left: 10px;\r\n    transition: 0.2s ease-in-out;\r\n    background-color: white;\r\n}\r\n\r\n.inputlogin {\r\n    margin-left: 10px;\r\n    border-radius: 10rem;\r\n    border: none;\r\n    width: 100%;\r\n    height: 100%;\r\n}\r\n\r\n.inputlogin:focus {\r\n    outline: none;\r\n}\r\n\r\n.inputFormlogin:focus-within {\r\n    border: 1.5px solid orange;\r\n}\r\n\r\n.flex-rowlogin {\r\n    display: flex;\r\n    flex-direction: row;\r\n    align-items: center;\r\n    gap: 10px;\r\n    justify-content: space-between;\r\n}\r\n\r\n.flex-rowlogin>div>label {\r\n    font-size: 14px;\r\n    color: black;\r\n    font-weight: 400;\r\n}\r\n\r\n.spanlogin {\r\n    font-size: 14px;\r\n    margin-left: 5px;\r\n    color: white;\r\n    font-weight: 500;\r\n    cursor: pointer;\r\n}\r\n\r\n.button-submitlogin {\r\n    position: relative;\r\n    display: inline-block;\r\n    padding: 15px 30px;\r\n    text-align: center;\r\n    letter-spacing: 1px;\r\n    text-decoration: none;\r\n    background: transparent;\r\n    transition: ease-out 0.5s;\r\n    border: 2px solid;\r\n    border-radius: 10em;\r\n    box-shadow: inset 0 0 0 0 blue;\r\n    margin: 20px 0 10px 0;\r\n    color: white;\r\n    font-size: 15px;\r\n    font-weight: 500;\r\n    height: 50px;\r\n    width: 100%;\r\n    cursor: pointer;\r\n}\r\n\r\n.button-submitlogin:hover {\r\n    color: white;\r\n    box-shadow: inset 0 -100px 0 0 royalblue;\r\n}\r\n\r\n.button-submitlogin:active {\r\n    transform: scale(0.9);\r\n}\r\n\r\n.plogin {\r\n    text-align: center;\r\n    color: white;\r\n    font-size: 14px;\r\n    margin: 5px 0;\r\n}\r\n\r\n.btnlogin {\r\n    margin-top: 10px;\r\n    width: 100%;\r\n    height: 50px;\r\n    border-radius: 10em;\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    font-weight: 500;\r\n    gap: 10px;\r\n    border: 1px solid #ededef;\r\n    background-color: white;\r\n    cursor: pointer;\r\n    transition: 0.2s ease-in-out;\r\n}\r\n\r\n.btnlogin:hover {\r\n    border: 1px solid orange;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
